import { colorConstants } from 'config/colorConstants';

//Figma: Navbar V2 nav panel > group header > chevron-down. The expanded state is the same
//glyph flipped, not a separate chevron-up.
const ChevronDown = ({
    fill = colorConstants.filterV2TextPrimary,
    direction = 'down',
}: {
    fill?: string;
    direction?: 'down' | 'up';
}) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.5286 5.5286C3.78894 5.26825 4.21105 5.26825 4.4714 5.5286L8 9.05719L11.5286 5.5286C11.7889 5.26825 12.2111 5.26825 12.4714 5.5286C12.7318 5.78895 12.7318 6.21106 12.4714 6.4714L8.4714 10.4714C8.21105 10.7318 7.78894 10.7318 7.5286 10.4714L3.5286 6.4714C3.26825 6.21106 3.26825 5.78895 3.5286 5.5286Z"
            fill={fill}
            transform={direction === 'up' ? 'rotate(180 8 8)' : undefined}
        />
    </svg>
);

export default ChevronDown;
